import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App/App';
import registerServiceWorker from './registerServiceWorker';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

setTimeout(() => {
  window.location.reload();
}, 30 * 60e3); // reload once in 30 minutes



// WEBPACK FOOTER //
// ./src/index.js